import * as React from 'react';

import styled from '@emotion/styled';
import { head } from 'lodash';

import { Picture } from '@shared/components/helpers/picture';
import { ImgixBG, ImgixFit } from '@shared/utils/imgix';

import { IItem } from '@admin/types/item';

const HeroContainer = styled.div`
  display: inline-block;
  width: 100%;
`;

export const Hero: React.FC<{
  selection: IItem;
  width: number;
  height: number;
  className?: string;
}> = ({ selection, width, height, className }) => {
  const images = selection.images || [];
  const image = images.length > 0 && typeof selection.hero === 'number' ? images[selection.hero] : head(images);
  const source = image?.state === 'uploaded' ? image.source : undefined;

  return (
    <HeroContainer>
      <Picture
        className={className}
        width={width}
        height={height}
        source={source}
        fit={ImgixFit.Fill}
        background={ImgixBG.White}
      />
    </HeroContainer>
  );
};
